import { uniqueId } from 'onyx-common/lodash'

const uniqueInstanceId = (prefix) => {
  const key = prefix ? `${prefix}-` : ''
  return uniqueId(key)
}

export default uniqueInstanceId
